import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { fetchUserProjectRequest } from 'core/userContext';

/**
 * React hook that returns a Redux-bound callback function for fetching the
 * current project with the user's session cookie. Once fetched, the current
 * project can be accessed via the Redux store.
 */
export const useFetchProjectForCurrentSessionCookie = () => {
  const dispatch = useDispatch();
  const fetchProject = useCallback(() => {
    dispatch(fetchUserProjectRequest());
  }, [dispatch]);

  return fetchProject;
};
